// src/components/modals/ForgotPasswordModal.jsx
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";
import "./ForgotPasswordModal.css";

const ForgotPasswordModal = ({ show, onClose, onSubmit }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("form"); // form | loading | success | error
  const [error, setError] = useState("");

  const handleSend = async () => {
    if (!email) {
      setError("Digite seu e‑mail de cadastro.");
      return;
    }
    setError("");
    setStatus("loading");
    try {
      await onSubmit(email);        // usa a promise que o Login.jsx devolve
      setStatus("success");
    } catch (err) {
      // pega erro retornado pela API
      const msg = err.response?.data?.error || "Erro ao enviar e‑mail.";
      setError(msg);
      setStatus("error");
    }
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div className="fp-modal-backdrop" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <motion.div className="fp-modal-dialog" initial={{ scale: 0.8 }} animate={{ scale: 1 }} exit={{ scale: 0.8 }} transition={{ duration: 0.2 }}>
            <div className="fp-modal-content">

              {status === "form" && (
                <>
                  <h5>Recuperar Senha</h5>
                  <p>Insira seu e‑mail de cadastro. Enviaremos as instruções para redefinir sua senha.</p>
                  {error && <div className="fp-error">{error}</div>}
                  <input
                    type="email"
                    className="form-control mb-3"
                    placeholder="Seu e‑mail de cadastro"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                  <div className="d-flex justify-content-end">
                    <button className="btn btn-secondary me-2" onClick={onClose}>Cancelar</button>
                    <button className="btn btn-primary" onClick={handleSend}>
                      {status === "loading" ? "Enviando..." : "Enviar"}
                    </button>
                  </div>
                </>
              )}

              {status === "success" && (
                <div className="text-center">
                  <FaCheckCircle size={48} className="text-success mb-3" />
                  <p>E‑mail de redefinição enviado. Verifique sua caixa de entrada.</p>
                  <button className="btn btn-primary" onClick={onClose}>Fechar</button>
                </div>
              )}

              {status === "error" && (
                <div className="text-center">
                  <p className="fp-error">{error}</p>
                  <button className="btn btn-secondary" onClick={() => { setStatus("form"); setError(""); }}>
                    Voltar
                  </button>
                </div>
              )}

            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ForgotPasswordModal;
